import { formatShanghaiDateTime } from '@/utils/datetime'

const BUSINESS_TYPE_LABELS = {
  AI_GENERATION: '生成任务',
  AI_STREAM_GENERATION: '提示词优化',
  AGENT_SESSION: '智能体会话',
  ENVIDEO_AI_CHAT: '智能体对话',
  TOPUP: '充值',
  CHECKIN: '签到',
  DAILY_CHECKIN: '签到',
  MEMBERSHIP: '会员'
}

export function todayShanghai() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Shanghai' })
}

export function formatDateTime(value) {
  return formatShanghaiDateTime(value)
}

export function formatBusinessType(value) {
  const raw = String(value || '').trim()
  if (!raw) return '-'
  if (BUSINESS_TYPE_LABELS[raw]) return BUSINESS_TYPE_LABELS[raw]
  const key = raw.toUpperCase()
  if (BUSINESS_TYPE_LABELS[key]) return BUSINESS_TYPE_LABELS[key]
  if (key.includes('STREAM')) return '提示词优化'
  if (key.includes('AGENT')) return '智能体会话'
  if (key.includes('GENERATION')) return '生成任务'
  return raw
}

export function formatOpsDescription(value) {
  const raw = String(value || '').trim()
  if (!raw) return '-'
  if (/^PROMPT\b/i.test(raw)) return '提示词优化'
  if (/^Agent\b/i.test(raw) || raw.includes('Agent 会话')) return '智能体会话结算'
  if (raw.startsWith('AI_STREAM_GENERATION') || raw.includes('流式生成')) return '提示词优化'
  if (raw.startsWith('AI_GENERATION')) return '生成任务'
  return raw
}
